import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";

const styles = theme => {
    return {
        root: {
            width: "100%",
        },
        counter: {
            position: "absolute",
            right: 0,
            top: 0,
            fontFamily: theme.fonts.medium,
            fontSize: "12px",
            lineHeight: "1.17",
            textAlign: "center",
            color: theme.palette.colors.white,
            backgroundColor: theme.palette.colors.coralPink,
            borderRadius: "50%",
            width: "20px",
            height: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        fixedContainer: {
            height: "120px",
            bottom: 0,
            left: 0,
            right: 0,
            position: "fixed",
            boxShadow: "0 -1px 2px 0 rgba(210, 206, 224, 0.5)",
            backgroundColor: theme.palette.colors.white,
            zIndex: "10000",
        },
        fixedContainerWrapper: {
            zIndex: "1000",
            position: "relative",
            width: "100%",
            height: "120px",
            display: "flex",
            alignItems: "flex-start",
        },
        leftPart: {
            width: "100%",
            height: "100%",
            flexShrink: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            position: "relative",
        },
        leftPartWrapper: {
            left: "50px",
            top: "50%",
            transform: "translateY(-50%)",
            position: "absolute",
            cursor: "pointer",
        },
        leftPartIcon: {
            color: theme.palette.colors.lightGrayishViolet,
            fontSize: "24px",
        },
        leftPartCounter: {
            position: "absolute",
            right: "-30px",
            top: "-20px",
            fontFamily: theme.fonts.medium,
            fontSize: "12px",
            lineHeight: "1.17",
            textAlign: "center",
            color: theme.palette.colors.white,
            backgroundColor: theme.palette.colors.coralPink,
            borderRadius: "50%",
            width: "20px",
            height: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        mainPart: {
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        rightPart: {
            height: "100%",
            width: "100%",
            flexShrink: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            paddingRight: "0",
            position: "relative",
        },
        rightPartWrapper: {
            position: "absolute",
            right: "68px",
            top: "50%",
            transform: "translateY(-50%)",
            "& span": {
                fontSize: "24px",
                color: theme.palette.colors.purplishBlue,
                cursor: "pointer",
            },
        },
        rootIsHide: {
            "& $fixedContainer": {
                bottom: "-120px",
            },
        },
        rootIsShow: {
            "& $fixedContainer": {
                bottom: "0",
                visibility: 1,
                transition: "visibility 0s linear, bottom .3s ease",
            },
        },
        rootIsCollapse: {
            "& $fixedContainer": {
                transition: "bottom .3s ease, visibility 0s linear .3s",
                bottom: "-120px",
                visibility: 0,
            },
        },
        [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
            fixedContainer: {
                height: "100px",
            },
            fixedContainerWrapper: {
                height: "100px",
            },
            leftPart: {
                justifyContent: "flex-end",
            },
            leftPartWrapper: {
                left: "30px",
            },
            rightPart: {
                justifyContent: "flex-start",
            },
            rightPartWrapper: {
                right: "50px",
            },
        },
        [`@media (max-width: ${theme.media.sm})`]: {
            counter: {
                fontSize: "10px",
                width: "18px",
                height: "18px",
                top: "-4px",
                right: "-2px",
            },
            fixedContainer: {
                height: "80px",
            },
            fixedContainerWrapper: {
                height: "80px",
            },
            leftPart: {
                width: 0,
            },
            leftPartWrapper: {
                left: "32px",
            },
            leftPartIcon: {
                fontSize: "20px",
            },
            leftPartCounter: {
                fontSize: "10px",
                width: "18px",
                height: "18px",
                right: "-15px",
                top: "-6px",
            },
            rightPart: {
                width: 0,
            },
            rightPartWrapper: {
                right: "35px",
                "& span": {
                    fontSize: "20px",
                },
            },
        },
    };
};

class ComparePopUp extends React.PureComponent {
    static defaultProps = {
        tariffs: [],
        isOpen: false,
        sliderComponent: null,
        classes: {},
        showWindow: () => {},
        onCompareClick: () => {},
        closeWindow: () => {},
    };

    constructor(props) {
        super(props);
    }

    render() {
        let classes = this.props.classes;
        let counter = this.props.tariffs.length
            ? this.props.tariffs.length
            : "+";
        return (
            <div
                className={classNames(classes.root, {
                    [classes.rootIsShow]: this.props.isOpen,
                    [classes.rootIsCollapse]: !this.props.isOpen,
                })}
            >
                <div
                    className={classes.fixedContainer}
                    datatest="compare_pop_up"
                >
                    <div className={classes.fixedContainerWrapper}>
                        <div className={classes.leftPart}>
                            <div className={classes.leftPartWrapper}>
                                <span
                                    className={classNames(
                                        classes.leftPartIcon,
                                        "icon32",
                                        "icon-list-1"
                                    )}
                                />
                                {!!this.props.tariffs.length && (
                                    <span className={classes.leftPartCounter}>
                                        {this.props.tariffs.length}
                                    </span>
                                )}
                            </div>
                        </div>
                        <Container
                            className={classes.mainPart}
                            onClick={this.props.onCompareClick}
                        >
                            {this.props.sliderComponent}
                        </Container>
                        <div className={classes.rightPart}>
                            <div className={classes.rightPartWrapper}>
                                <span
                                    datatest="close_popup_button"
                                    className="icon24 icon-close"
                                    onClick={this.props.closeWindow}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(ComparePopUp);
export { ComparePopUp as TestComparePopUp };
